import { launchPagesUrl } from "../urls";
import { createLaunchPage, joinWaitlist } from "../../graphql/operations";

export const postLaunchPage = (data) => createLaunchPage({
  slug: data.slug,
  companyId: data.companyId,
});

export const postToWaitlist = (data) => joinWaitlist({
  slug: data.slug,
  email: data.email,
});

// Increment page views count
export const updatePageViews = async (data) => {
  try {
    const response = await fetch(`${launchPagesUrl}/${data.slug}/page-views`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Failed to update page views count');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};